type Props = {
  detailsSelector: string
}

export default function openSingleDetail(el: HTMLElement, 
  {
    detailsSelector
  }: Props
  ) {

  const items: NodeListOf<HTMLElement> = el.querySelectorAll(
    detailsSelector
  )

  function openSingleDetail() {
    items.forEach(activeItem => {
      activeItem.addEventListener("click", () => {
        items.forEach(item => {
          if (item !== activeItem) {
            resetActiveState(item)
          }
        })
      })
    })
  }

  openSingleDetail()

  function resetActiveState(item: HTMLElement) {
    item.removeAttribute("open")
  }
}
